import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addUser } from "../services/addUserService";

export const useAddUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addUser,
    onSuccess: () => {
      // Invalidate the user list query to refresh the data
      queryClient.invalidateQueries({ queryKey: ["listUser"] }); // object with queryKey
    },
    onError: (error) => {
      console.error("Failed to add user:", error);
    },
  });
};